{
  "Accessibility Menu": "പ്രവേശയോഗ്യത മെനു",
  "Reset settings": "ക്രമീകരണങ്ങൾ പുനഃസജ്ജമാക്കുക",
  "Close": "അടയ്ക്കുക",
  "Content Adjustments": "ഉള്ളടക്ക ക്രമീകരണങ്ങൾ",
  "Adjust Font Size": "അക്ഷരത്തിന്റെ വലുപ്പം ക്രമീകരിക്കുക",
  "Highlight Title": "ശീർഷകം ഹൈലൈറ്റ് ചെയ്യുക",
  "Highlight Links": "ലിങ്കുകൾ ഹൈലൈറ്റ് ചെയ്യുക",
  "Readable Font": "വായിക്കാൻ എളുപ്പമുള്ള ഫോണ്ട്",
  "Color Adjustments": "നിറ ക്രമീകരണങ്ങൾ",
  "Dark Contrast": "ഇരുണ്ട കോൺട്രാസ്റ്റ്",
  "Light Contrast": "ഇളം കോൺട്രാസ്റ്റ്",
  "High Contrast": "ഉയർന്ന കോൺട്രാസ്റ്റ്",
  "High Saturation": "ഉയർന്ന സാചുരേഷൻ",
  "Low Saturation": "കുറഞ്ഞ സാചുരേഷൻ",
  "Monochrome": "മോനോക്രോം",
  "Tools": "ഉപകരണങ്ങൾ",
  "Reading Guide": "വായനാ ഗൈഡ്",
  "Stop Animations": "ആനിമേഷനുകൾ നിർത്തുക",
  "Big Cursor": "വലിയ കർസർ",
  "Increase Font Size": "ഫോണ്ട് വലുപ്പം വർദ്ധിപ്പിക്കുക",
  "Decrease Font Size": "ഫോണ്ട് വലുപ്പം കുറയ്ക്കുക",
  "Letter Spacing": "അക്ഷരങ്ങൾക്കിടയിലെ ഇടവ്",
  "Line Height": "ലൈൻ ഉയരം",
  "Font Weight": "ഫോണ്ട് ഭാരം",
  "Dyslexia Font": "ഡിസ്ലെക്സിയ ഫോണ്ട്",
  "Language": "ഭാഷ",
  "Open Accessibility Menu": "പ്രവേശയോഗ്യത മെനു തുറക്കുക",
  "Accessibility Profiles": "പ്രവേശയോഗ്യത പ്രൊഫൈലുകൾ",
  "Seizure Safe Profile": "സീസർ സുരക്ഷിത പ്രൊഫൈൽ",
  "Stops animations and reduces color saturation.": "ആനിമേഷനുകൾ നിർത്തുകയും നിറത്തിന്റെ സാചുരേഷൻ കുറയ്ക്കുകയും ചെയ്യുന്നു.",
  "Blind Profile": "കാഴ്‌ച്ച ഇല്ലാത്തവർക്കുള്ള പ്രൊഫൈൽ",
  "Activates the screen reader for auditory navigation.": "ശ്രാവ്യ നാവിഗേഷനിനായി സ്ക്രീൻ റീഡർ പ്രവർത്തിപ്പിക്കുന്നു.",
  "Visually Impaired Profile": "കാഴ്ചക്കുറവുള്ളവർക്കുള്ള പ്രൊഫൈൽ",
  "Enhances contrast and readability for low vision.": "കുറഞ്ഞ കാഴ്ചയ്ക്കുള്ള കോൺട്രാസ്റ്റും വായനാസുഖവും മെച്ചപ്പെടുത്തുന്നു.",
  "ADHD Friendly Profile": "ADHD സൗഹൃദ പ്രൊഫൈൽ",
  "Reduces distractions for better focus.": "കൂടുതൽ ശ്രദ്ധയ്ക്കായി ശ്രദ്ധാവ്യവസ്ഥ കുറയ്ക്കുന്നു.",
  "Cognitive & Learning Profile": "ജ്ഞാനപരവും പഠനപരവുമായ പ്രൊഫൈൽ",
  "Helpful tools for reading and comprehension.": "വായനക്കും മനസ്സിലാക്കലിനും സഹായകമായ ഉപകരണങ്ങൾ.",
  "Motor Impaired Profile": "ചലനശേഷി കുറവുള്ളവർക്കുള്ള പ്രൊഫൈൽ",
  "Optimizes the site for keyboard-only navigation.": "കീബോർഡ് മാത്രം ഉപയോഗിച്ച് നാവിഗേഷൻ ചെയ്യുന്നതിനായി സൈറ്റ് മെച്ചപ്പെടുത്തുന്നു.",
  "Headings": "ശീർഷകങ്ങൾ",
  "Landmarks": "ലാൻഡ്‌മാർക്കുകൾ",
  "Links": "ലിങ്കുകൾ",
  "Focus element": "ഫോകസ് ഘടകം",
  "Visit link": "ലിങ്ക് സന്ദർശിക്കുക"
}